import { render } from "./AsideLinkComp.vue?vue&type=template&id=90d870f6&scoped=true&ts=true"
import script from "./AsideLinkComp.vue?vue&type=script&lang=ts"
export * from "./AsideLinkComp.vue?vue&type=script&lang=ts"

import "./AsideLinkComp.vue?vue&type=style&index=0&id=90d870f6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d870f6"]])

export default __exports__